import { FaSearch, FaShoppingCart } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import styled from "styled-components";

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: ${({ theme }) => theme.siteWidth};
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 9;
  padding: 0 5px;

  @media ${({ theme }) => theme.devices.tablet} {
    width: Calc(100% - 40px);
    display: flex;
    background-color: ${props => props.theme.colors.white};
    box-shadow: none;
    justify-content: space-around;
    left: 0;
    right: 0;
    padding: 15px 20px;
    flex-direction: row;
    align-items: center;
    box-shadow: ${({ theme }) => theme.shadow.vertical};
  }

  &.white {
    background-color: #fff;
  }
`;

export const TopContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.green.dark};
  padding: 0 30px;
  @media ${({ theme }) => theme.devices.tablet} {
    background: none;
    align-items: center;
    display: flex;
    padding-right: 0;
  }
`;

export const MenuSecundary = styled.div``;

export const MiddleContainer = styled.div`
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${({ theme }) => theme.devices.tablet} {
    padding: 0px;
    padding-right: 20px;
    width: 100%;
  }
`;

export const Logo = styled(Link)`
  width: 275px;
  font-weight: 700;
  text-transform: uppercase;
  text-decoration: none;
  font-family: ${props => props.theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSize.md};
  color: ${props => props.theme.colors.white.normal};
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  img {
    width: 100%;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    width: 230px;
    padding: 0;
    top: 5px;
    bottom: 5px;
    margin: 10px 0;
  }

  @media ${({ theme }) => theme.devices.laptopM} {
    width: 230px;
    padding: 0;
    top: 5px;
    bottom: 5px;
  }
`;

export const FormContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white.normal};
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.grayNew.gray1};
  margin: 0px 20px 0 20px;

  @media ${({ theme }) => theme.devices.laptopM} {
    margin: 0px 10px 0 10px;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    position: relative;
    z-index: 8;
    margin: 20px 15px 0 15px;
    border-radius: 4px;
    border: none;
  }
`;

export const SearchTitle = styled.h1`
  font-weight: 300;
  color: ${({ theme }) => theme.colors.green.normal};
  margin: 0 0 20px 0;
`;
export const SearchCategory = styled.div``;

export const SearchSubmit = styled.div`
  margin-top: 15px;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-end;
`;

export const SearchDescription = styled.p`
  text-align: center;
  margin: 0 0 20px 0;
  font-size: ${({ theme }) => theme.fontSize.mm};
  font-weight: normal;
  color: ${({ theme }) => theme.colors.gray.light};
`;
export const SelectWrapper = styled.div`
  justify-content: center;
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.colors.grayNew.gray1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayNew.gray1};
  max-height: 36px;
  overflow: visible;
`;

export const Search = styled.input`
  border: none;
  padding: 0px 10px;
  height: auto;
  max-height: 60px;
  min-height: 36px;
  font-size: ${({ theme }) => theme.fontSize.mm};
  font-family: ${({ theme }) => theme.fonts.inter};
  border: 1px solid ${({ theme }) => theme.colors.grayNew.gray1};
  border-right: none;
  @media ${({ theme }) => theme.devices.tablet} {
    border-radius: 5px 0 0 5px;
  }
`;

export const SearchIcon = styled(FaSearch)`
  font-size: 19px;
  margin: 0 auto;
  font-weight: thin;
  color: ${props => props.theme.colors.white.normal};
`;

export const SearchBtn = styled.button`
  background-color: ${({ theme }) => theme.colors.green.normal};
  border: none;
  color: ${({ theme }) => theme.colors.white.normal};
  margin: 0;
  padding: 0 10px;
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 10px;
  cursor: pointer;
  border-radius: 0 4px 4px 0;
`;

export const LogoContainer = styled.div`
  display: flex;
  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
    place-content: center;
  }
`;

export const CartConainer = styled(NavLink)`
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;
`;

export const CartIcon = styled(FaShoppingCart)`
  font-size: 28px;
  margin: 0 auto;
  cursor: pointer;
  padding-right: 20px;
  color: ${props => props.theme.colors.gray.normal};
  @media ${({ theme }) => theme.devices.laptopM} {
    font-size: 24px;
  }
`;

export const BadgeCircle = styled.div`
  background-color: ${({ theme }) => theme.colors.green.normal};
  color: ${({ theme }) => theme.colors.white.normal};
  font-size: ${({ theme }) => theme.fontSize.sm};
  position: absolute;
  display: flex;
  width: 20px;
  height: 20px;
  top: -5px;
  right: 10px;
  border-radius: 50%;
  justify-content: center;
`;

export const TickerMobile = styled.div`
  margin-top: 130px;
`;

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 15%;
  align-items: center;
  @media ${({ theme }) => theme.devices.tablet} {
    display: none;
  }
`;

export const DividerVertical = styled.div`
  width: 1px;
  height: 25px;
  background-color: ${({ theme }) => theme.colors.grayNew.gray4};
  margin: 0 0 0 10px;
`;

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 30%;
`;

export const Buttonn = styled.button`
  padding: 10px 20px;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: ${({ theme }) => theme.fontSizePx.sm};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white.normal};
  border: none;
  border-radius: 6px;
  background-color: #53b167;
  text-wrap: nowrap;
  padding: 5px 5px;
  margin: 0 10px;
  &:focus {
    outline: none;
  }
  height: 40px;
  @media ${({ theme }) => theme.devices.laptopM} {
  }
`;
